import React from "react"

import LoadingSpinner from "./LoadingSpinner"

import type { InviteImportProgress } from "../../utils/inviteClientsInBatches"

type Props = InviteImportProgress & {
  /** e.g. "Importing clients…" vs "Saving invitations…" */
  title?: string
}

export default function ClientImportProgress({
  completedBatches,
  batchCount,
  processedRows,
  totalRows,
  title = "Importing clients…"
}: Props) {
  const pct = totalRows > 0 ? Math.min(100, Math.round((processedRows / totalRows) * 100)) : 0
  const batchLine =
    batchCount > 0
      ? completedBatches === 0
        ? `Starting batch 1 of ${batchCount}…`
        : completedBatches >= batchCount
          ? `All ${batchCount} batches sent`
          : `Batch ${completedBatches} of ${batchCount} complete · sending next…`
      : null

  return (
    <div
      className="flex flex-col items-center gap-4 py-6 px-4"
      role="status"
      aria-live="polite"
      aria-busy="true">
      <LoadingSpinner className="" spinnerClassName="" />
      <p className="text-center font-manrope text-lg font-semibold text-[#0b3954]">{title}</p>
      {batchLine ? (
        <p className="text-center font-manrope text-sm font-medium text-[#55778a]">{batchLine}</p>
      ) : null}
      <p className="text-center font-manrope text-sm text-[#0b3954]">
        {processedRows.toLocaleString()} of {totalRows.toLocaleString()} clients processed
      </p>
      <div className="h-2.5 w-full max-w-md overflow-hidden rounded-full bg-[#e8f0f3]">
        <div
          className="h-full rounded-full bg-teal transition-[width] duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="max-w-md text-center font-manrope text-xs text-[#6b7280]">
        This runs in your browser in several steps to stay within server limits. Please keep this tab
        open until you see the confirmation message.
      </p>
    </div>
  )
}
